<template>

  <div class="card friend-card" @click="showModal">
    <div class="card-body">
      <div class="d-flex">
        <div class="p-2 w-100">
          <h4>
<!--            <ProfilePicture :user="friend" size="50"></ProfilePicture> <ProfileName :user="friend"></ProfileName>-->
            <img :src="$imagePathBase + 'friend-pic-default.png'" :height=50 class="profile-pic" referrerPolicy="no-referrer">
            <img :src="$imagePathBase + 'friend-plus.png'" :height=20 class="plus-sign" referrerPolicy="no-referrer">
            <span class="invite-text">invite a friend</span>
          </h4>
        </div>
      </div>
    </div>

  </div>

  <GenericModal v-if="show_code_modal" @modal-closed="show_code_modal=false">
    <template #header>
      <h6>share link to add friend</h6>
    </template>

    <div style="text-align: center">
      <QRCodeVue3 :value="link"
                  :width="250" :height="250"
                  :image="logo"
                  :imageOptions="{margin: 2, imageSize: 0.25}"
                  :dotsOptions="{type: 'extra-rounded', color: '#b49823ff'}"
                  :cornersSquareOptions="{ color: '#b49823ff' }"
                  :cornersDotOptions="{ color: '#b49823ff' }"
                  :backgroundOptions="{ color: 'transparent' }"
                  :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
      />
      <div class="d-grid gap-2">
        <button class="btn btn-sm btn-block btn-mol btn-copy-friend-link" type="button" @click="copyLinkToClipboard">
          <span v-if="!textCopied"><i class="fa fa-clipboard" aria-hidden="true"></i> copy link to clipboard
<!--            <br><span style="opacity: 50%;">{{link}}</span>-->
          </span>
          <span v-else>copied!</span>
        </button>
      </div>
    </div>

  </GenericModal>



</template>


<script>


import GenericModal from "@/components/modal/GenericModal.vue";
import QRCodeVue3 from "qrcode-vue3";
import {userStore} from "@/userStore";
import analytics from "@/analytics";

export default {
  name: 'FriendCard_ShowCode',
  components: {QRCodeVue3, GenericModal},
  computed: {
    link() {
      return `${this.$apiPath}/connect-with/${userStore.getFriendConnectionId()}`;
    },
    logo() {
      return this.$imagePathBase + 'logo-goldtext.png';
    }
  },
  data() {
    return {
      show_code_modal: false,
      show_code_time: 0,
      textCopied: false
    }
  },
  watch: {
    show_code_modal(newValue) {
      if ( newValue ) {
        this.show_code_time = Date.now();
      } else {
        const elapsedTime = Date.now() - this.show_code_time;
        analytics.sendEvent('friend_code_viewed', {
          seconds: elapsedTime / 1000
        });
      }
    }
  },
  methods: {
    showModal() {
      this.show_code_modal = true;
      this.textCopied = false;
    },
    copyLinkToClipboard() {
      navigator.clipboard.writeText( this.link );
      this.textCopied = true;
      analytics.sendEvent('friend_code_copied');
    }
  }
}
</script>


<style scoped>

.profile-films-viewed-graphic {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.friend-card {
  isolation: isolate;
  overflow: hidden;

  text-decoration: inherit;

  border-style: dashed;
  border-width: 2px;
  background-color: var(--mol-friends-bg);
  border-color: var(--mol-friends-border-color);
  color: var(--mol-friends-color);
  margin: 18px;

  &:hover {
    box-shadow: 0 0 0 1px var(--mol-friends-color);
  }
}

.invite-text {
  margin-left: -15px;
}

.profile-pic {
  position: relative;
  border-radius: 50%;
  border-style: solid;
  border-width: 0.1px;
  border-color: lightgrey;
}
.plus-sign {
  position: relative;
  left: -15px;
  bottom: -15px;
}

.btn-copy-friend-link {
  margin: 20px auto 20px auto;
  width: 230px;
  background-color: var(--mol-color-gold-text);
  color: var(--mol-color-gold-background);
  font-weight: 500;
}



</style>